import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/health")({
	loader: () => {
		return new Response(
			JSON.stringify({
				status: "ok",
				timestamp: new Date().toISOString(),
			}),
			{
				status: 200,
				headers: {
					"Content-Type": "application/json",
					"Cache-Control": "no-cache, no-store, must-revalidate",
				},
			},
		);
	},
});
